<app-tool-list
  [tableData]="data"
  [tableFilters]="filters"
  [searchParams]="searchParams"
  [toolTransferExportParams]="toolTransferExportParams"
  dataType="transfer"
  source="transfer"></app-tool-list>
